// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3w1Gj","icon":"styles_icon__hE1NB"};